// Vendor libraries
import { CommonModule } from '@angular/common';
// Modules
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class CheckboxGroupModule {
}
CheckboxGroupModule.ɵfac = function CheckboxGroupModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CheckboxGroupModule)(); };
CheckboxGroupModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CheckboxGroupModule });
CheckboxGroupModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, IconModule] });
